export default "__VITE_ASSET__5d6378e5__"